// Українська — мова за замовчуванням, також джерело ключів для інших мов
const ua = {
    // загальне
    "common.loading": "Очікування відповіді...",

    // навбар та меню
    "nav.login": "Вхід",
    "nav.profile": "Профіль",
    "nav.logout": "Вийти з облікового запису",
    "nav.stats": "Статистика",
    "nav.topPlayers": "Топ гравців",
    "nav.leaders": "Лідери",
    "nav.shop": "Магазин",

    // банер
    "header.donateInfo": "При донаті від 1000грн – бонус до поповнення +10%. Це добровільні донати для розвитку проєкту, які не підлягають поверненню.",
    "header.bonus": "Ваш особистий бонус +{n}% 👍",
    "header.noBonus": "У вас поки немає особистого бонусу 😕",

    // вибір сервера
    "servers.title": "Виберіть тип серверу",
    "servers.text": "Від цього залежить які предмети доступні для покупки, на сервері <b>trio</b> доступні не всі предмети.",

    // футер
    "footer.agreement": "Угода користувача",
    "footer.privacy": "Політика конфіденційності",
    "footer.about": "Про нас",

    // товар
    "product.buy": "Купити",
    "product.loginSteam": "Увійти через Steam",
    "product.friendPlaceholder": "SteamId друга",
    "product.noServer": "Ви не обрали сервер покупки!",
    "product.noFriend": "Ви не вказали steamId свого друга!",
    "product.badSteamId": "Невірний SteamID: він має містити рівно 17 цифр!",
    "product.error": "Сталася помилка",
    "product.confirmBefore": "Ви точно хочете придбати",
    "product.confirmOnServer": "на сервер",
    "product.pickup": "Після придбання можете забрати на клавішу <b>\"u\"</b>",
    "product.yes": "Так",
    "product.cancel": "Скасувати",

    // статистика
    "stats.title": "Топ гравців",
    "stats.subtitle": "Найкращі гравці наших серверів за вбивствами, K/D та дальністю пострілу",
    "stats.kills": "Вбивства",
    "stats.killsLabel": "вбивств",
    "stats.kd": "K/D",
    "stats.distance": "Дальність",
    "stats.distanceLabel": "найдальший постріл",
    "stats.playtime": "Час у грі",
    "stats.playtimeLabel": "награно",
    "stats.deaths": "Смерті",
    "stats.farthest": "Найдальше",
    "stats.time": "Час",
    "stats.player": "Гравець",
    "stats.error": "Статистика тимчасово недоступна. Спробуйте пізніше.",
    "stats.empty": "Поки що немає даних.",
    "stats.hours": "год",
    "stats.minutes": "хв",
    "stats.meters": "м",
} as const;

export type TranslationKey = keyof typeof ua;
export default ua;
